import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CameraIcon, LightbulbIcon, LayoutIcon } from 'lucide-react';
export function ProductPresentation() {
  const benefits = [{
    icon: <LayoutIcon className="w-7 h-7 text-[#92400e]" data-id="element-251" data-mp="1bfvxes2ldm25" />,
    title: 'Técnica de Vetado',
    desc: 'Domina el arte de crear vetas realistas y efectos de profundidad.',
    image: 'https://cdn.magicpatterns.com/uploads/e66qxYiFMkLg9ZjxufFTz8/tecnica_de_vetado.webp',
    colSpan: 'md:col-span-2'
  }, {
    icon: <CameraIcon className="w-7 h-7 text-[#92400e]" data-id="element-252" data-mp="284v6g9b02rve" />,
    title: 'Mezcla Perfecta',
    desc: 'Proporciones exactas para evitar piezas pegajosas o mal curadas.',
    image: 'https://cdn.magicpatterns.com/uploads/tAgbEbo3Hr31mptMrRSJqU/mezcla_perfecta.webp',
    colSpan: 'md:col-span-1'
  }, {
    icon: <LightbulbIcon className="w-7 h-7 text-[#92400e]" data-id="element-253" data-mp="2m3bafshha49u" />,
    title: '0 Burbujas',
    desc: 'Métodos probados para eliminar el aire y lograr transparencia total.',
    image: 'https://cdn.magicpatterns.com/uploads/7vtHcyGEMbzBFvRHQw8ZTC/0_burbujas.webp',
    colSpan: 'md:col-span-1'
  }, {
    icon: <BookOpenIcon className="w-7 h-7 text-[#92400e]" data-id="element-254" data-mp="38zvefm88xpwi" />,
    title: 'Acabado Espejo',
    desc: 'El secreto del lijado y pulido para un brillo profesional duradero.',
    image: 'https://cdn.magicpatterns.com/uploads/gFhQBtZHecYdrLmryUkQFx/acabado_esepejo.webp',
    colSpan: 'md:col-span-2'
  }];
  return <section className="py-12 px-4 relative z-10 bg-[#fdf8f3] overflow-hidden" data-id="element-255" data-mp="3dy6ony2ge2f9">
      {/* Clean, bright atmosphere */}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-256" data-mp="3ryhh35jevp2j">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#d97706]/5 rounded-full blur-[150px]" data-id="element-257" data-mp="3n17s1qzxpff8" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[#92400e]/5 rounded-full blur-[120px]" data-id="element-258" data-mp="1xli3fhyld4xw" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-259" data-mp="1snzq7fdjk3k3">
        <div className="text-center mb-20" data-id="element-260" data-mp="3sp6dl7a6spsx">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#d97706]/5 border border-[#d97706]/20 text-[#92400e] text-sm font-bold mb-8 tracking-wide" data-id="element-261" data-mp="3sqhg73rwbrig">
            <div className="w-2 h-2 rounded-full bg-[#d97706]" data-id="element-262" data-mp="p7o3et6xz6pc" />
            LA SOLUCIÓN PROFESIONAL
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 tracking-tight leading-[1.1]" data-id="element-263" data-mp="t7ydagxuuh9h">
            Todo lo que necesitás para{' '}
            <span className="text-[#d97706]" data-id="element-264" data-mp="13d81ugtusxy2">empezar hoy</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-gray-600 max-w-2xl mx-auto font-normal leading-relaxed" data-id="element-265" data-mp="zco1z5hwbg88">
            El sistema completo diseñado para llevarte de cero a experto en
            tiempo récord.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-266" data-mp="2a0ldzaatwqrj">
          {benefits.map((benefit, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          duration: 0.5
        }} className={`${benefit.colSpan} group relative bg-white rounded-[2.5rem] overflow-hidden border border-gray-100 shadow-sm hover:shadow-[0_30px_70px_rgba(217,119,6,0.08)] transition-all duration-500`} data-id="element-267" data-mp="1uhshix4vsbik" data-mpi={i}>
              <div className="flex flex-col h-full" data-id="element-268" data-mp="28j4v51wkk11a">
                {/* Image Section */}
                <div className="relative h-64 md:h-72 overflow-hidden" data-id="element-269" data-mp="2w8qubpcxyg9a">
                  <img src={benefit.image} alt={benefit.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-270" data-mp="2w7fshv323ikt" />
                  <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent opacity-60" data-id="element-271" data-mp="klnaia8qtffw" />

                  {/* Floating Icon Badge */}
                  <div className="absolute bottom-6 left-8 bg-white/90 backdrop-blur-md p-4 rounded-2xl shadow-lg border border-white/50 group-hover:scale-110 transition-transform duration-300" data-id="element-272" data-mp="zccnni5rl4me">
                    {benefit.icon}
                  </div>
                </div>

                {/* Text Content */}
                <div className="p-8 md:p-10 pt-4" data-id="element-273" data-mp="1ovss58un8dy">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 tracking-tight" data-id="element-274" data-mp="gkjwzue63vhu">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-lg" data-id="element-275" data-mp="1ryxg6lxz7mrj">
                    {benefit.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}